import { PropTypes } from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { getApiErrorCode, getApiErrorMessage } from '../api/apiUtils';
import RequestErrorWrapper from '../RequestError/RequestError';
import withErrorLogger from './withErrorLogger';

const ErrorWithLogger = withErrorLogger(RequestErrorWrapper);

const withHttpRequest = (WrappedComponent, errorLogType = 'react_request_error') => {
  // eslint-disable-next-line react/display-name
  function helperFunction(props) {
    const { requestAction } = props;
    const [responseData, setResponseData] = useState();
    const [fetchError, setFetchError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { accountId } = useSelector((state) => state.internalReducer.internal);

    const fetchData = async () => {
      try {
        const response = await requestAction();
        setResponseData(response.data);
      } catch (error) {
        setFetchError(error);
      } finally {
        setLoading(false);
      }
    };

    const onReloadData = () => {
      setLoading(true);
      fetchData();
    };

    useEffect(() => {
      if (!accountId) return;
      fetchData();
    }, [accountId]);

    if (accountId && loading) {
      return <WrappedComponent {...props} loading />;
    }

    if (fetchError) {
      const apiErrorMessage = getApiErrorMessage(fetchError);

      const errorLog = {
        log_type: errorLogType,
        log_message: 'Fetch API Error',
        error: apiErrorMessage,
      };

      return (
        <ErrorWithLogger
          errorLog={errorLog}
          source={getApiErrorCode(fetchError)}
          errorMessage={apiErrorMessage}
          displayNextSteps
        />
      );
    }
    return responseData ? <WrappedComponent {...props} data={responseData} reloadData={onReloadData} /> : null;
  }

  helperFunction.propTypes = {
    requestAction: PropTypes.func.isRequired,
  };

  return helperFunction;
};

export default withHttpRequest;
